import axios from 'axios'

/**
 * init class API
 * @param opt
 * @returns {CallCenterCrmApi}
 * @constructor
 */

function CallCenterCrmApi (opt) {
  if (!(this instanceof CallCenterCrmApi)) {
    return new CallCenterCrmApi(opt)
  }
  opt = opt || {}
  this.classVersion = '1.0.0'
  this.api = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 9000000
  })
}

/**
 * Request to the server,
 * You fixed: https://gist.github.com/pranavrajs/66bccee3f8ba100742a1273db6f587af
 * @param url
 * @param callback
 * @returns {axios.Promise}
 * @private
 */
CallCenterCrmApi.prototype._requestAuthPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Authorization': 'Bearer 23432567654',
    'Content-Type': contentType
  }
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  })
}

CallCenterCrmApi.prototype._requestDataPost = function (url, contentType, data, callback) {
  var headers = {
    'Authorization': 'Bearer eb7ca14c72364a3c696f0fc95e256a08S1UHQsDk3YEc1TK/iMVaitNoRbTLbvDUqAGEnXA4ezoJtgw=',
    'Content-Type': contentType
  }
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}

CallCenterCrmApi.prototype._requestDataPostFileAttachment = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Authorization': 'Bearer 23432567654',
    'Content-Type': contentType,
    responseType: 'blob'
  }
  return this.api.post(url, data, headers).then((response) => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}

CallCenterCrmApi.prototype._requestDataGet = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Authorization': 'Bearer 23432567654',
    'Content-Type': contentType
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
CallCenterCrmApi.prototype._requestFileDataGet = function (url, contentType, data, callback) {
  var headers = {
    'Authorization': 'Bearer 23432567654',
    responseType: 'arraybuffer'
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
CallCenterCrmApi.prototype.emailVerify = async function (data, callback) {
  const requestUrl = 'api/v1/auth/emailVerify'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.login = async function (data, callback) {
  const requestUrl = 'api/v1/auth/webLogin'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.getUserLoginPermission = async function (data, callback) {
  const requestUrl = 'api/v1/auth/getPermission'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// Roles Api Start Here.....
CallCenterCrmApi.prototype.getRoleList = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/systemSetting/role/list'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.addNewRole = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/systemSetting/role/save'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.getRoleDetails = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/systemSetting/role/detail'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.getPermissionList = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/systemSetting/role/getPermissionList'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// Company Api start
CallCenterCrmApi.prototype.uploadCompanyLogo = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/systemSetting/company/uploadCompanyLogo'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.getCompanydata = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/systemSetting/company/data'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.updateCompanydata = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/systemSetting/company/update'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// Temp Storage api
CallCenterCrmApi.prototype.uploadfileInTemp = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/tempStorage/uploadFileInTemp'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.deleteMultipleFileFromTemp = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/tempStorage/deleteMultipleFile'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.globalCompanySearch = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/crm/company/globalSearch'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CallCenterCrmApi.prototype.globalCompanySearchByNumberEmail = async function (data, callback) {
  const requestUrl = 'api/v1/callcenter/crm/company/getCompanyByEmailNumber'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
export default CallCenterCrmApi



// WEBPACK FOOTER //
// ./src/api/CallCenterCrmApi.js